import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/app/constants/queryKeys';
import { QueryTimers } from '@/infra/network/query';
import { podcastsService } from '@/modules/podcasts/services';

const podcastDetailsQueryOptions = (projectId: string, podcastId: string) =>
  queryOptions({
    gcTime: QueryTimers.FIVE_MINUTES,
    staleTime: QueryTimers.FIVE_MINUTES,
    refetchInterval: QueryTimers.FIVE_MINUTES,
    queryKey: queryKeys.podcasts.detail(projectId, podcastId),
    queryFn: () => podcastsService.getPodcastDetails({ projectId, podcastId }),
  });

export { podcastDetailsQueryOptions };
